import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { openRequestModal } from '../../actions/modals';
import ComponentTable from '../../components/ComponentTable';
import { getNewsSource } from './getNewsSource';
import { Button } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import VisibilityIcon from '@mui/icons-material/Visibility';

export default function AdminNewsComponent() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { info, emulation } = useSelector(state => state.user);
    const role_id = emulation.length ? emulation[emulation.length - 1].info.role_id : info.role_id;
    const userId = info.user_id;
    const source = getNewsSource(role_id);

    const handleOpenAddNewsModal = () => {
        dispatch(
            openRequestModal({
                opened: true,
                data: {
                    header: t('news.addNews'),
                    modaltype: 'AddNews',
                },
            })
        );
    };

    const actions = [
        {
            title: t('news.view'),
            onClick: id =>
                dispatch(
                    openRequestModal({
                        opened: true,
                        data: {
                            id: id,
                            header: t('news.viewNews'),
                            modaltype: 'ViewNews',
                        },
                    })
                ),
            Icon: VisibilityIcon,
        },
        {
            title: t('modals_name.edit'),
            onClick: id =>
                dispatch(
                    openRequestModal({
                        opened: true,
                        data: {
                            id: id,
                            header: t('news.editNews'),
                            modaltype: 'AddNews',
                        },
                    })
                ),
            Icon: Edit,
        },
        {
            title: t('news.delete'),
            onClick: id =>
                dispatch(
                    openRequestModal({
                        opened: true,
                        data: {
                            id: id,
                            header: t('news.removeNews'),
                            modaltype: 'RemoveNews',
                        },
                    })
                ),
            Icon: Delete,
        },
    ];

    return (
        <Fragment>
            <Button
                variant="contained"
                onClick={handleOpenAddNewsModal}
                style={{
                    width: '150px',
                    padding: '5px',
                    borderRadius: '4px',
                    margin: '15px',
                }}
            >
                {t('news.addNews')}
            </Button>

            <ComponentTable
                source={source}
                actions={actions}
                selectable={true}
                enableFilter
                title={t('modals.list')}
                enableSettings
                toolbarvisible={true}
                typeTable="moneybox"
            />
        </Fragment>
    );
}
